<lib-dialog-layout>
    <ng-container title>
        @if (!hasUploadErrors) {
            <div>
                {{data.Title}}
            </div>
        } @else {
            <div i18n="@@UploadComponentUploadUnsuccessfulLabel">
                Upload Unsuccessful
            </div>
        }
    </ng-container>
    <ng-container content>
        @if (hasEmptyFiles) {
            <p i18n="@@UploadComponentUploadUnsuccessfulText">Error: Empty File Array, nothing to upload!</p>
        } @else {
            @if (hasUploadErrors) {
                <div>
                    <p class="mb-2" i18n="@@UploadComponentTroubleUploadingText">We had some trouble uploading your file(s). You can try to upload them again, or click "Ignore & Continue" to save without these files.</p>
                    <lib-banner
                        [isDismissable]="false"
                        [kind]="StatusKind.Danger">
                        <ng-container text>
                            <ng-container i18n="@@UploadComponentUploadingFailedText">
                                The following file(s) couldn't be uploaded:
                            </ng-container>
                            @if (failedFiles.length <= 3) {
                                @for(file of failedFiles; track file) {
                                    <li>{{file}}</li>
                                }
                            }
                        </ng-container>
                    </lib-banner>
                    @if(failedFiles.length > 3) {
                        <div class="margin-top-16">
                            <lib-clipboard-card-scroll>
                                <ng-container body>
                                    <ul class="margin-bottom-0 padding-left-16">
                                        @for(file of failedFiles; track file) {
                                            <li>{{file}}</li>   
                                        }
                                    </ul>
                                </ng-container>
                            </lib-clipboard-card-scroll>
                        </div>
                    }
                </div>
            } @else if (isFinalizing) {
                <div>
                    <lib-progress-bar></lib-progress-bar>
                    <p class="mt-2" i18n="@@UploadComponentFinalizingLabel">Finalizing...</p>
                </div>
            } @else {
                <div>
                    <lib-progress-bar [kind]="ProgressBarKind.Determinate" [value]="progressBarValue"></lib-progress-bar>
                    <p class="mt-2" i18n="@@UploadComponentUploadingProgressText">Uploading Attachments... {{progressBarValue | formatDecimal:0:0}}% Complete</p>
                </div>
            }
        }
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            @if (hasUploadErrors) {
                <lib-button
                [role]="ButtonRole.Primary"
                    id="LibraryDialogSecondaryButton"
                    (clicked)="TryAgainAction()">
                    <ng-container label i18n="@@UploadComponentTryAgainLabel">
                        Try Again
                    </ng-container>
                </lib-button>
                }
                <lib-button
                [role]="ButtonRole.Secondary"
                    id="LibraryDialogSecondaryButton"
                    [kind]="ButtonKind.NeutralSecondary"
                    (clicked)="CancelUploadAction()">
                    <ng-container label i18n="@@CommonCancelButton">
                        Cancel
                    </ng-container>
                </lib-button>
            @if (hasUploadErrors) {
                <lib-button
                [role]="ButtonRole.Tertiary"
                    id="LibraryDialogSecondaryButton"
                    [kind]="ButtonKind.Secondary"
                    (clicked)="IgnoreContinueAction()">
                    <ng-container label i18n="@@UploadComponentIgnoreAndContinueLabel">
                        Ignore & Continue
                    </ng-container>
                </lib-button>
            }
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>